import { useQuery } from '@tanstack/react-query';

import { downloadAttachment } from '@/attachment/api/DownloadAttachment';

export const useDownloadAttachment = (id?: number) => {
  const { data, isLoading } = useQuery({
    queryKey: ['attachment', id],
    queryFn: () => downloadAttachment(id!),
    enabled: !!id,
  });

  return {
    pdfBlob: data,
    isLoading,
  };
};
